import { render, staticRenderFns } from "./LangFormDropdown.vue?vue&type=template&id=1992b021&"
import script from "./LangFormDropdown.vue?vue&type=script&lang=js&"
export * from "./LangFormDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports